package com.essntl.features.qbauth.data.repository

import com.essntl.core.supabase.getAll
import com.essntl.core.supabase.getById
import com.essntl.core.supabase.getChannel
import com.essntl.core.supabase.removeChannel
import com.essntl.core.utils.repository.RealtimeAction
import com.essntl.core.utils.repository.Repository
import com.essntl.features.qbauth.data.supabase.QbAuthDto
import com.essntl.features.qbauth.data.supabase.QbAuthSupabaseDataSource
import com.essntl.features.qbauth.domain.model.QbAuthModel
import com.essntl.features.qbauth.domain.repository.QbAuthRepository
import io.github.jan.supabase.realtime.RealtimeChannel
import kotlinx.coroutines.NonCancellable
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.mapNotNull
import kotlinx.coroutines.withContext
import org.koin.core.annotation.Single

@Single(binds = [QbAuthRepository::class])
internal class QbAuthRepositoryImpl internal constructor(
    private val supabase: QbAuthSupabaseDataSource,
) : Repository(), QbAuthRepository {
    private var channel: RealtimeChannel? = null

    override suspend fun getAll(): Result<List<QbAuthModel>> =
        runCatching {
            supabase
                .getAll()
                .map { it.toModel() }
        }

    override suspend fun getById(id: String): Result<QbAuthModel> =
        runCatching {
            supabase
                .getById(id = id)
                .toModel()
        }

    override suspend fun getFlow(): Result<Flow<QbAuthModel>> =
        runCatching {
            if (channel != null) unsubscribe()

            channel = supabase.getChannel()
            realTimeActions<QbAuthModel, QbAuthDto>(
                channel = channel!!,
                tableName = supabase.tableName,
                mapper = {
                    it.toModel()
                },
            )
                .mapNotNull {
                    println("QbAuthRepositoryImpl: getFlow: $it")
                    when (it) {
                        is RealtimeAction.Insert ->
                            it.item

                        is RealtimeAction.Update ->
                            it.item

                        else ->
                            null
                    }
                }
        }

    override suspend fun unsubscribe(): Result<Unit> =
        runCatching {
            channel?.let {
                withContext(NonCancellable) {
                    it.unsubscribe()
                    supabase.removeChannel(it)
                    channel = null
                }
            }
        }
}
